import {
  TextField,
  Grid,
  Toolbar,
  Typography,
  Button,
} from "@material-ui/core";
import React from "react";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import PickerMonth from "../../../partials/pickerMonth";
import { parseCountry } from "../../../utils/setting";
import moment from "moment";
import "moment/locale/vi";
// Style
import { toolbarStyles } from "./styles";

class EnhancedTableToolbar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      to: "",
      from: "",
    };
    this.handleChangeDate = this.handleChangeDate.bind(this);
  }
  async componentDidMount() {
    const _this = this;
    await Promise.all([
      this.props.bookingDispatch.getLatestDate(),
      this.props.bookingDispatch.getOldestDate(),
    ]);
    let oldestDate = this.props.bookingState.oldestDate;
    let lastestDate = this.props.bookingState.lastestDate;
    this.setState({ to: lastestDate, from: oldestDate }, function () {
      _this.props.fetchData(_this.state.from, _this.state.to);
    });
  }
  handleChangeDate(value, name) {
    const _this = this;
    this.setState({ [name]: value }, function () {
      _this.props.fetchData(_this.state.from, _this.state.to);
    });
  }
  render() {
    const { classes, t, i18n } = this.props;
    const { from, to } = this.state;
    const lng = parseCountry(i18n.language);
    moment.locale(lng);
    return (
      <Toolbar className={classes.root}>
        <Grid container spacing={3} alignItems="center">
          <Grid item md={12} className={classes.title}>
            <Typography
              color="inherit"
              variant="h6"
              className={classes.titleText}
            >
              {t("dashboard_booking_total")} {this.props.total}{" "}
              {t("dashboard_booking_bookings")}
            </Typography>
          </Grid>

          <Grid item md={12}>
            <Grid container spacing={3}>
              <Grid item md={6} className={classes.containerInput}>
                <Typography
                  color="inherit"
                  variant="body1"
                  className={classes.label}
                >
                  {t("dashboard_booking_from")}
                </Typography>
                <div className={classes.inputBase}>
                  <PickerMonth
                    handleChange={this.handleChangeDate}
                    nameInput="from"
                    time={this.state.from}
                  />
                </div>
              </Grid>
              <Grid item md={6} className={classes.containerInput}>
                <Typography
                  color="inherit"
                  variant="body1"
                  className={classes.label}
                >
                  {t("dashboard_booking_to")}
                </Typography>
                <div className={classes.inputBase}>
                  <PickerMonth
                    handleChange={this.handleChangeDate}
                    nameInput="to"
                    time={this.state.to}
                  />
                </div>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Toolbar>
    );
  }
}

EnhancedTableToolbar.propTypes = {
  classes: PropTypes.object.isRequired,
};
const mapState = (state) => ({
  bookingState: state.booking,
});

const mapDispatch = (dispatch) => ({
  bookingDispatch: dispatch.booking,
});

export default connect(
  mapState,
  mapDispatch
)(translate("translations")(withStyles(toolbarStyles)(EnhancedTableToolbar)));
